import { CheckmarkCircle16Filled, ErrorCircle16Filled, Warning16Filled } from '@/components/Icon'
import { UPDATE_STATUS_LABEL } from '@/features/pulseDemo/updateLabels'
import styles from './pulseCards.module.scss'

const ICONS = { done: CheckmarkCircle16Filled, attention: Warning16Filled, failed: ErrorCircle16Filled }

/** A run result's outcome as a coloured icon, labelled for screen readers. */
export default function UpdateStatusIcon({ status }) {
  const Icon = ICONS[status] ?? ICONS.done
  return (
    <Icon
      role="img"
      aria-label={UPDATE_STATUS_LABEL[status] ?? UPDATE_STATUS_LABEL.done}
      className={`${styles.statusIcon} ${styles[`status_${status}`] ?? styles.status_done}`}
    />
  )
}
